var NAMESPACE = "https://lendi";
export var IDENTITY_TOKEN_USER_ID_KEY = "".concat(NAMESPACE, "/userId");
export var IDENTITY_TOKEN_ROLE_KEY = "".concat(NAMESPACE, "/userRole");
export var IDENTITY_TOKEN_PROFILE_KEY = "".concat(NAMESPACE, "/userProfile");
export var IDENTITY_TOKEN_EXISTING_KEY = "".concat(NAMESPACE, "/existingUser");
export var IDENTITY_TOKEN_AUTH_ID_KEY = "".concat(NAMESPACE, "/authId");
export var IDENTITY_TOKEN_CONNECTION_KEY = "".concat(NAMESPACE, "/connection");
export var RETURNURL_STORAGE_KEY = 'lendi_auth:return_url';
export var SAFETY_NET_COOKIE_NAME = 'safetynet';
export var LG_APP_AUTH_SESSION_COOKIE_NAME = 'authsession';
//# sourceMappingURL=consts.js.map